__turbopack_context__.v({
  "borderTop": "tvcJFG_borderTop",
  "borderTopNone": "tvcJFG_borderTopNone",
  "container": "tvcJFG_container",
  "desktopMainLink": "tvcJFG_desktopMainLink",
  "desktopSubMenuBtn": "tvcJFG_desktopSubMenuBtn",
  "enLangButtonStyles": "tvcJFG_enLangButtonStyles",
  "hamMenuWrapper": "tvcJFG_hamMenuWrapper",
  "logoContainer": "tvcJFG_logoContainer",
  "logoContainerTitle": "tvcJFG_logoContainerTitle",
  "logoContainerVerticalLine": "tvcJFG_logoContainerVerticalLine",
  "mainMenuBtn": "tvcJFG_mainMenuBtn",
  "menuContainer": "tvcJFG_menuContainer",
  "mobileMainMenuBtn": "tvcJFG_mobileMainMenuBtn",
  "mobileSubMenuBtn": "tvcJFG_mobileSubMenuBtn",
  "mobileSubMenuBtnTitle": "tvcJFG_mobileSubMenuBtnTitle",
  "mobileSubMenuContainer": "tvcJFG_mobileSubMenuContainer",
  "rightArrowTitlSubStyles": "tvcJFG_rightArrowTitlSubStyles",
  "searchBtn": "tvcJFG_searchBtn",
  "secondContainerBg": "tvcJFG_secondContainerBg",
  "secondLogoContainerVerticalLine": "tvcJFG_secondLogoContainerVerticalLine",
  "subMenuContainer": "tvcJFG_subMenuContainer",
});
